"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var handlers_1 = require("./handlers");
var form_1 = require("../form");
var ValidationStatusType;
(function (ValidationStatusType) {
    ValidationStatusType["Error"] = "error";
    ValidationStatusType["Warning"] = "warning";
    ValidationStatusType["Success"] = "success";
})(ValidationStatusType = exports.ValidationStatusType || (exports.ValidationStatusType = {}));
exports.Validate = React.memo(function (_a) {
    var message = _a.message, field = _a.for, _b = _a.type, type = _b === void 0 ? "error" /* Error */ : _b, customHandler = _a.customHandler, validationProps = __rest(_a, ["message", "for", "type", "customHandler"]);
    var form = React.useContext(form_1.FormContext);
    var extractValueFromStringOrObject = function (value, prop) {
        var message = '';
        if (typeof value === 'string')
            message = value;
        else if (value && typeof value === 'object' && prop) {
            if (typeof value[prop] === 'string')
                message = value[prop];
            else if (React.isValidElement(value[prop]))
                message = value[prop];
        }
        else if (React.isValidElement(value))
            message = value;
        return message;
    };
    React.useEffect(function () {
        var validations = [];
        Object.keys(validationProps).forEach(function (prop) {
            var handler = handlers_1.validationProps[prop];
            if (typeof handler === 'function') {
                validations.push({
                    type: type,
                    name: prop,
                    error: extractValueFromStringOrObject(message, prop),
                    validate: handler(validationProps[prop]),
                });
            }
        });
        if (typeof customHandler === 'function') {
            validations.push({
                type: type,
                name: 'custom',
                error: extractValueFromStringOrObject(message, 'custom'),
                validate: customHandler,
            });
        }
        form.addValidation(field, validations);
        return function () {
            form.removeValidations(field, validations);
        };
    }, []);
    return null;
});
